import React from 'react';
import { connect } from 'react-redux';

import fetchStylistsBySalon from 'actions/stylist/fetchStylistsBySalon.action';
import PUSHER from 'config/pusher.singleton';
import { withTranslation } from 'providers/GILT.provider';
import { PUSHER_EVENT_SMS_CREDITS_AVAILABLE } from 'providers/Pusher.provider';
import selectEffectiveUserRole from 'selectors/selectEffectiveUserRole';

import {
  bulkDeleteClient,
  bulkOptoutClient,
  clearLastDatesSelected,
  filterData,
  filterLastVisit,
  filterLoyalty,
  filterNextVisit,
  filterService,
  filterStylist,
  filterTimeRange,
  getAllClientsList,
  getAllClientsPhoneList,
  getClientsCalculatedList,
  getClientsCancelledLastMonth,
  hideNoPhoneClients,
  markAllClientsSelect,
  markClientSelect,
  purchaseSmsBundle,
  resetBulkDeleteResponse,
  setHidePhoneChecked,
  setOptChecked,
  setTimeRange,
  showOnlyOptedClients,
  sortClientList,
} from 'clientCommunications/actions';
import ClientFilterBar from 'clientCommunications/components/Clients/ClientFilterBar';
import ClientHeader from 'clientCommunications/components/Clients/ClientHeader';
import ClientList from 'clientCommunications/components/Clients/ClientsList';
import PurchaseSmsCreditDialog from 'clientCommunications/components/Clients/PurchaseSmsCreditDialog';
import { SMS_CREDITS_PUSHER } from 'clientCommunications/constants';
import { setDatePickerDate } from 'reports/actions';
import { getCategories, getClientsList } from 'salon/actions';
import SmsButtonNew from 'scheduler/components/common/SmsButtonNew';
import { trackEvent } from 'tracking/actions';

class ClientLayout extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {
      purchaseModal: false,
      isLastVisit: false,
      isHideChecked: false,
      isNextVisit: false,
      isLoyalty: false,
      isOptChecked: false,
      isServiceOpen: false,
      isStylistOpen: false,
      isTimeRange: false,
      smsComposeModalOpen: false,
      currentFilter: '',
    };
  }

  UNSAFE_componentWillMount() {
    PUSHER.redux.subscribe({
      channelName: `${this.props.salonId}_channel`,
      eventName: PUSHER_EVENT_SMS_CREDITS_AVAILABLE,
      actionType: SMS_CREDITS_PUSHER,
    });

    this.props.fetchStylistsBySalon(this.props.salonId);
    this.props.getCategories(this.props.salonId);
    if (this.props.match.params.bucketType === 'cancelations' && this.state.currentFilter !== 'timeRange') {
      this.props.getClientsCancelledLastMonth(this.props.salonId);
    }
    if (this.props.match.params.bucketType === 'withphone' && this.state.currentFilter !== 'timeRange') {
      this.props.getAllClientsPhoneList(this.props.salonId);
    }
    if (this.props.match.params.bucketType === 'list' && this.state.currentFilter !== 'timeRange') {
      this.props.getAllClientsList(this.props.salonId);
    } else if (this.state.currentFilter !== 'timeRange') {
      this.props.getClientsCalculatedList(this.props.salonId, this.props.match.params.bucketType);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    PUSHER.redux.subscribe({
      channelName: `${nextProps.salonId}_channel`,
      eventName: PUSHER_EVENT_SMS_CREDITS_AVAILABLE,
      actionType: SMS_CREDITS_PUSHER,
    });
  }

  componentWillUnmount() {
    PUSHER.redux.unsubscribe({
      channelName: `${this.props.salonId}_channel`,
      eventName: PUSHER_EVENT_SMS_CREDITS_AVAILABLE,
      actionType: SMS_CREDITS_PUSHER,
    });
  }

  bulkDelete = (selectedClients, checkNotes) => {
    this.props.bulkDeleteClient(this.props.salonId.toString(), selectedClients, checkNotes);
    const interval =
      (() => {
        if (this.props.bulkDeleteSuccess) {
          if (!this.props.clients_with_notes || this.props.clients_with_notes.length === 0) {
            this.props.resetBulkDeleteResponse();
            this.props.getAllClientsList(this.props.salonId);
            this.props.getClientsCalculatedList(this.props.salonId, this.props.match.params.bucketType);

            clearInterval(interval);
          }
        }
      },
      500);
  };
  bulkOptout = (selectedClients) => {
    this.props.bulkOptoutClient(this.props.salonId.toString(), selectedClients);
    setTimeout(() => {
      this.props.getAllClientsList(this.props.salonId);
      this.props.getClientsCalculatedList(this.props.salonId, this.props.match.params.bucketType);
    }, 1000);
  };
  gotoBilling = () => {
    const oldpath = this.props.history.location.pathname;
    let newPath;
    if (oldpath.indexOf('day') > 0) {
      newPath = `${oldpath.split('day/')[0]}settings/billing`;
    } else if (oldpath.indexOf('communications') > 0) {
      newPath = `${oldpath.split('communications/')[0]}settings/billing`;
    } else {
      newPath = `${oldpath.split('week/')[0]}settings/billing`;
    }
    this.props.history.push({ pathname: newPath });
  };
  showPopup = (popup) => {
    this.setState({ [popup]: true });
  };
  showPurchasePopup = (tf) => {
    this.setState({ purchaseModal: tf });
  };
  showSmsPopup = (tf) => {
    this.setState({ smsComposeModalOpen: tf });
  };
  toggleHideChange = () => {
    this.setState(
      {
        isHideChecked: !this.state.isHideChecked,
      },
      () => {
        if (this.props.selectedStylistIds.length > 0 || this.props.selectedServices.length > 0) {
          this.props.setHidePhoneChecked(this.state.isHideChecked);
          this.props.filterData(this.props.salonId, this.props.match.params.bucketType, this.props.selectedStylistIds, this.props.selectedServices);
        } else {
          this.props.hideNoPhoneClients(this.state.isHideChecked);
        }
        if (this.state.isHideChecked) {
          this.props.trackEvent('hide_no_mobile_clients');
        }
      },
    );
  };
  toggleOptChange = () => {
    this.setState({
      isOptChecked: !this.state.isOptChecked,
    });
    if (this.props.selectedStylistIds.length > 0 || this.props.selectedServices.length > 0) {
      this.props.setOptChecked(!this.state.isOptChecked);
      this.props.filterData(this.props.salonId, this.props.match.params.bucketType, this.props.selectedStylistIds, this.props.selectedServices);
    } else {
      this.props.showOnlyOptedClients(this.state.isOptChecked);
    }

    if (this.state.isOptChecked) {
      this.props.trackEvent('show_only_opt_in');
    }
  };
  openDropdown = (filter) => {
    this.setState({ currentFilter: filter });
    switch (filter) {
      case 'stylist': {
        if (this.props.selectedStylistIds.length === 0) {
          const initStylist = [];
          this.props.stylists.forEach((stylist) => initStylist.push(stylist.id));

          this.props.filterStylist(initStylist);
        }
        this.setState({
          isStylistOpen: !this.state.isStylistOpen,
          isServiceOpen: false,
          isLastVisit: false,
          isNextVisit: false,
          isTimeRange: false,
          isLoyalty: false,
        });
        break;
      }
      case 'service': {
        this.setState({
          isStylistOpen: false,
          isServiceOpen: !this.state.isServiceOpen,
          isLastVisit: false,
          isNextVisit: false,
          isTimeRange: false,
          isLoyalty: false,
        });
        break;
      }
      case 'lastVisit': {
        this.setState({
          isStylistOpen: false,
          isServiceOpen: false,
          isLastVisit: !this.state.isLastVisit,
          isNextVisit: false,
          isTimeRange: false,
          isLoyalty: false,
        });
        break;
      }
      case 'nextVisit': {
        this.setState({
          isStylistOpen: false,
          isServiceOpen: false,
          isLastVisit: false,
          isTimeRange: false,
          isLoyalty: false,
          isNextVisit: !this.state.isNextVisit,
        });
        break;
      }
      case 'timeRange': {
        this.setState({
          isStylistOpen: false,
          isServiceOpen: false,
          isLastVisit: false,
          isNextVisit: false,
          isLoyalty: false,
          isTimeRange: !this.state.isTimeRange,
        });
        break;
      }

      case 'loyalty': {
        this.setState({
          isStylistOpen: false,
          isServiceOpen: false,
          isLastVisit: false,
          isNextVisit: false,
          isTimeRange: false,
          isLoyalty: !this.state.isLoyalty,
        });
        break;
      }
      default:
        this.setState({
          isStylistOpen: false,
          isServiceOpen: false,
          isLastVisit: false,
          isNextVisit: false,
          isTimeRange: false,
          isLoyalty: false,
        });
        break;
    }
  };
  closePurchaseModal = () => {
    this.setState({ purchaseModal: false });
  };

  render() {
    const { isStylistOpen, isServiceOpen, isLastVisit, isNextVisit, isTimeRange, isLoyalty } = this.state;

    const lastDatesSelected = this.props.lastDatesSelected;

    const currClientList = this.props.clientList.filter((c) => c.selected === true && c.show === true);
    //  filter the duplicate phone numbers
    const filterList = [...new Map(this.props.clientList.filter((c) => c.selected === true && c.show === true && c.phone !== null).map((item) => [item.phone, item])).values()];
    const currNoPhoneClients = this.props.clientList.filter((c) => c.selected === true && c.show === true && c.phone !== null && !c.requested_opt_out);
    const selectedClient = currNoPhoneClients.length;
    const countFiltered = filterList.length;

    const totalCost = currNoPhoneClients.reduce((prev, next) => prev + (next.visits_total_cost === null ? 0 : next.visits_count === 0 ? 0 : next.visits_total_cost / next.visits_count), 0);
    const revenuOpt = Math.round(totalCost);
    const clientId = currNoPhoneClients.map((c) => c.id);
    const calcCostToText = Math.round(this.props.pricePerSMS * countFiltered * 100) / 100;
    let optoutNote;
    if (this.props.numClientsToBeSentOptout > 0) {
      optoutNote = this.props.t('allClients.optOutInfo', { count: this.props.numClientsToBeSentOptout });
    }

    const duplicated = this.props.originalRecipientsCount - this.props.unique_recipients_count;

    return (
      <div>
        <div>
          <ClientHeader
            {...this.props}
            bucketType={this.props.match.params.bucketType}
            allClients={this.props.isFetching ? 0 : this.props.clientList.length}
            clientsSelected={this.props.isFetching ? 0 : selectedClient}
            clientList={this.props.clientList}
            selectedClients={currClientList}
            costToText={calcCostToText}
            revenueSum={revenuOpt}
            showPopup={this.showPopup}
            showPurchasePopup={this.showPurchasePopup}
            onlineBooking={this.props.onlineBooking}
            trackEvent={this.props.trackEvent}
            has_billing={this.props.has_billing}
            bulkDelete={this.bulkDelete}
            bulkOptout={this.bulkOptout}
            resetBulkDeleteResponse={this.props.resetBulkDeleteResponse}
            deleted_count={this.props.deleted_count}
            bulkDeleteSuccess={this.props.bulkDeleteSuccess}
            upcoming_clients={this.props.upcoming_clients}
            upcoming_count={this.props.upcoming_count}
            bulkOptoutSuccess={this.props.bulkOptoutSuccess}
            clients_with_notes={this.props.clients_with_notes}
            markClientSelect={this.props.markClientSelect}
            getClientsCalculatedList={this.props.getClientsCalculatedList}
            getAllClientsList={this.props.getAllClientsList}
            getClientsList={this.props.getClientsList}
            sms_credits_available={this.props.sms_credits_available}
            tableToExcel="table-clients-name-email-to-excel"
          />

          <ClientFilterBar
            isLoyalty={isLoyalty}
            bucketType={this.props.match.params.bucketType}
            filterData={this.props.filterData}
            filterLastVisit={this.props.filterLastVisit}
            filterNextVisit={this.props.filterNextVisit}
            filterService={this.props.filterService}
            filterStylist={this.props.filterStylist}
            isLastVisit={isLastVisit}
            isNextVisit={isNextVisit}
            isStylistOpen={isStylistOpen}
            isServiceOpen={isServiceOpen}
            isTimeRange={isTimeRange}
            salonId={this.props.salonId}
            openDropdown={this.openDropdown}
            getClientsCalculatedList={this.props.getClientsCalculatedList}
            selectedLastVisit={this.props.selectedLastVisit}
            selectedNextVisit={this.props.selectedNextVisit}
            selectedServices={this.props.selectedServices}
            selectedLoyalty={this.props.selectedLoyalty}
            services={this.props.categoriesAndServices}
            stylists={this.props.stylists}
            trackEvent={this.props.trackEvent}
            selectedTimeRange={this.props.selectedTimeRange}
            filterTimeRange={this.props.filterTimeRange}
            filterLoyalty={this.props.filterLoyalty}
            setTimeRange={this.props.setTimeRange}
            lastDatesSelected={lastDatesSelected}
            clearLastDatesSelected={this.props.clearLastDatesSelected}
            clearTimeRangeClient={this.props.clearTimeRangeClient}
          />

          {this.props.isFetching ? (
            <>
              {!this.state.purchaseModal ? (
                <div className="spinner-container in-marketing-clients">
                  <div className="load-spinner" />
                  <span className="spinner-text">{this.props.t('allClients.loadingClients')}</span>
                </div>
              ) : (
                <div />
              )}
            </>
          ) : (
            <ClientList
              clientList={this.props.clientList}
              isHideChecked={this.state.isHideChecked}
              isOptChecked={this.state.isOptChecked}
              markClientSelect={this.props.markClientSelect}
              markAllClientsSelect={this.props.markAllClientsSelect}
              sortClientList={this.props.sortClientList}
              toggleHideChange={this.toggleHideChange}
              toggleOptChange={this.toggleOptChange}
              trackEvent={this.props.trackEvent}
            />
          )}
        </div>
        {this.state.smsComposeModalOpen && (
          <SmsButtonNew
            clientId={clientId}
            duplicated={duplicated}
            optoutNote={optoutNote}
            unique_recipients_count={this.props.unique_recipients_count}
            bucketType={this.props.match.params.bucketType}
            smsComposeModalOpen={this.state.smsComposeModalOpen}
            showParentSmsPopup={this.showSmsPopup}
            numClientsToBeSentOptout={this.props.numClientsToBeSentOptout}
          />
        )}
        {this.state.purchaseModal && (
          <PurchaseSmsCreditDialog
            closePopup={this.closePurchaseModal}
            purchaseSmsBundle={this.props.purchaseSmsBundle}
            salonId={this.props.salonId}
            errorMessage={this.props.errorMessage}
            gotoBilling={this.gotoBilling}
            isFetching={this.props.isFetching}
            sms_credits_available={this.props.sms_credits_available}
            showPurchasePopup={this.showPurchasePopup}
            permission={this.props.permission}
            variantButton="normal"
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isFetching: state.clientCommunications.isFetching,
  salonId: state.currentSalon.id,
  has_billing: state.currentSalon.has_billing,
  onlineBooking: state.currentSalon.online_booking,
  stylists: state.currentSalon.stylistList,
  categoriesAndServices: state.currentSalon.services,
  pricePerSMS: state.currentSalon.price_per_sms,
  ncobTinyUrl: state.currentSalon.ncob_tiny_url,
  consultation_link: state.currentSalon.consultation_link,
  clients_with_notes: state.clientCommunications.clients_with_notes,
  ...state.clientCommunications,
  sms_credits_available: state.clientCommunications.sms_credits_available,
  permission: selectEffectiveUserRole(state),
});

export const mapDispatchToProps = (dispatch) => ({
  getCategories(salonId) {
    dispatch(getCategories(salonId));
  },
  fetchStylistsBySalon(id) {
    dispatch(fetchStylistsBySalon(id));
  },
  filterData(salonId, apiSuffix, selectedStylistIds, selectedServices) {
    dispatch(filterData(salonId, apiSuffix, selectedStylistIds, selectedServices));
  },
  filterLastVisit(option) {
    dispatch(filterLastVisit(option));
  },
  filterNextVisit(option) {
    dispatch(filterNextVisit(option));
  },
  filterService(selectedServices) {
    dispatch(filterService(selectedServices));
  },
  filterStylist(selectedStylistIds) {
    dispatch(filterStylist(selectedStylistIds));
  },
  filterTimeRange() {
    dispatch(filterTimeRange());
  },
  filterLoyalty(isAnyAmount, amount, isAnyNumber, number) {
    dispatch(filterLoyalty(isAnyAmount, amount, isAnyNumber, number));
  },
  getClientsCancelledLastMonth(salonId) {
    dispatch(getClientsCancelledLastMonth(salonId));
  },
  getAllClientsPhoneList(salonId) {
    dispatch(getAllClientsPhoneList(salonId));
  },
  getAllClientsList(salonId) {
    dispatch(getAllClientsList(salonId));
  },
  getClientsList(salonId) {
    dispatch(getClientsList(salonId));
  },
  getClientsCalculatedList(salonId, apiSuffix) {
    dispatch(getClientsCalculatedList(salonId, apiSuffix));
  },
  markClientSelect(clientId, mark) {
    dispatch(markClientSelect(clientId, mark));
  },
  markAllClientsSelect(mark) {
    dispatch(markAllClientsSelect(mark));
  },
  showOnlyOptedClients(mark) {
    dispatch(showOnlyOptedClients(mark));
  },
  hideNoPhoneClients(mark) {
    dispatch(hideNoPhoneClients(mark));
  },
  setOptChecked(optValue) {
    dispatch(setOptChecked(optValue));
  },
  setHidePhoneChecked(isHideValue) {
    dispatch(setHidePhoneChecked(isHideValue));
  },
  sortClientList(tableRow, isAsc) {
    dispatch(sortClientList(tableRow, isAsc));
  },
  trackEvent(event, properties) {
    dispatch(trackEvent(event, properties));
  },
  setDatePickerDate(startDate, endDate) {
    dispatch(setDatePickerDate(startDate, endDate));
  },
  setTimeRange(fromDate, toDate) {
    dispatch(setTimeRange(fromDate, toDate));
  },
  clearLastDatesSelected() {
    dispatch(clearLastDatesSelected());
  },
  bulkDeleteClient(salonId, clientIds, checkNotes) {
    dispatch(bulkDeleteClient(salonId, clientIds, checkNotes));
  },
  bulkOptoutClient(salonId, clientIds) {
    dispatch(bulkOptoutClient(salonId, clientIds));
  },
  resetBulkDeleteResponse() {
    dispatch(resetBulkDeleteResponse());
  },
  purchaseSmsBundle(data) {
    dispatch(purchaseSmsBundle(data));
  },
});

const ClientLayoutHoc = connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ClientLayout));

export default ClientLayoutHoc;
